import React, { useState } from "react";

const APPROVAL_STATUS_BADGE_TYPE = {
  승인: "success",
  반려: "danger",
  진행중: "warning",
};

const getApprovalStatusBadgeType = (result) =>
  APPROVAL_STATUS_BADGE_TYPE[result] ?? "neutral";

const PaymentForm = ({
  formColumns = [],
  approvalLine = [],
  datas = {},
  recordNo,
  onSummaryClick,
}) => {
  const [showApprovalStatus, setShowApprovalStatus] = useState(
    () => window.innerWidth > 768,
  );

  return (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 16,
          flexWrap: "wrap",
        }}
      >
        {datas.uuu_bp_record_url && (
          <a
            className="detail-form-title-link"
            href={datas.uuu_bp_record_url}
            target="_blank"
            rel="noreferrer"
          >
            유니파이어 레코드 바로가기
          </a>
        )}
        {onSummaryClick && (
          <button
            type="button"
            onClick={onSummaryClick}
            style={{
              background: "none",
              border: "none",
              color: "#0060b7",
              cursor: "pointer",
              fontSize: 14,
              fontWeight: 600,
              textDecoration: "underline",
              padding: 0,
            }}
          >
            품의 요약 보기
          </button>
        )}
      </div>
      <div className="detail-form-contents-body">
        <div className="detail-form-approval-status-section">
          <button
            className="detail-form-approval-status-toggle"
            type="button"
            onClick={() => setShowApprovalStatus((prev) => !prev)}
          >
            {showApprovalStatus ? "상황 조회 숨기기" : "상황 조회"}
          </button>

          {showApprovalStatus && (
            <div className="detail-form-approval-status-table-wrapper">
              <div className="detail-form-approval-status-title">결재 상황</div>
              <div className="detail-form-approval-status-card">
                <table className="detail-form-approval-status-table">
                  <thead>
                    <tr>
                      <th>순번</th>
                      <th>구분</th>
                      <th>성명</th>
                      <th>상태</th>
                      <th>결재 코멘트</th>
                      <th>처리일시</th>
                    </tr>
                  </thead>
                  <tbody>
                    {approvalLine.map((c, i) => {
                      const {
                        ApprvSeq,
                        SHIAppTypePD,
                        SignUserNM,
                        SHIAppResult,
                        JobPosition,
                        SHIAppTime,
                        LoAComment,
                      } = c;

                      const commentReplace = (LoAComment ?? "")
                        .replaceAll("\\n", "\n")
                        .replaceAll("", "\n");

                      const statusText = SHIAppResult ?? "-";

                      return (
                        <tr
                          key={`${SignUserNM ?? "user"}-${SHIAppTime ?? "time"}-${i}`}
                        >
                          <td>{ApprvSeq}</td>
                          <td>{SHIAppTypePD}</td>
                          <td>
                            {SignUserNM} {JobPosition}
                          </td>
                          <td>
                            <span
                              className={`detail-form-status-badge detail-form-status-badge-${getApprovalStatusBadgeType(statusText)}`}
                            >
                              <span className="detail-form-status-badge-dot" />
                              {statusText}
                            </span>
                          </td>
                          <td className="detail-form-approval-comment-cell">
                            {commentReplace ?? ""}
                          </td>
                          <td>{SHIAppTime}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
        <div className="detail-form-fields-grid">
          {(() => {
            const columns = formColumns ?? [];
            const oddRunLastIndexes = new Set();
            let runStart = 0;

            columns.forEach((c, i) => {
              if (c.type === "divider" || i === columns.length - 1) {
                const runEnd = c.type === "divider" ? i : i + 1;
                const runLength = runEnd - runStart;

                if (runLength % 2 === 1) {
                  oddRunLastIndexes.add(runEnd - 1);
                }

                runStart = i + 1;
              }
            });

            return columns.map((c, i) => {
              const { type, title, field, unit, value } = c;

              if (type === "divider") {
                return (
                  <div
                    key={i}
                    className="detail-form-field-card detail-form-field-card-full detail-form-field-card-divider"
                  >
                    <div className="detail-form-field-label">{title}</div>
                  </div>
                );
              }

              const isOddRunLast = oddRunLastIndexes.has(i);

              return (
                <div
                  key={i}
                  className={`detail-form-field-card${isOddRunLast ? " detail-form-field-card-full" : ""}`}
                >
                  <div className="detail-form-field-label">{title}</div>
                  <div className="detail-form-field-value">
                    {value ??
                      `${(datas?.[field] ?? "").toString()?.replaceAll("<br />", "\n")} ${unit ?? ""}`}
                  </div>
                </div>
              );
            });
          })()}
        </div>
      </div>
    </>
  );
};

export default PaymentForm;

// const sampleApprovalLine = [
//   {
//     SHIAppTypePD: "기안",
//     SignUserNM: "홍길동",
//     JobPosition: "프로",
//     SHIAppTime: "2026-01-02 01:01:01",
//     SHIAppResult: "승인",
//   },
//   {
//     SHIAppTypePD: "결재",
//     SignUserNM: "홍길동",
//     JobPosition: "프로",
//     SHIAppTime: "2026-01-02 01:01:01",
//     SHIAppResult: "승인",
//   },
//   {
//     SHIAppTypePD: "결재",
//     SignUserNM: "홍길동",
//     JobPosition: "프로",
//     SHIAppTime: "2026-01-02 01:01:01",
//     SHIAppResult: "반려",
//     LoAComment: "반려 코멘트",
//   },
// ];
